module.exports = __webpack_public_path__ + "img/xinjin1.79fba937.png";